<template>
  <v-dialog v-model="dialog" width="1200px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Template.title")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="templateKeyword"
              @text="KeyWord = $event"
              :label="$t('Template.Fields.template_name')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <div
              class="caption grey--text input-chip-group-label"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Material.choose") }}
            </div>
            <v-chip-group v-model="chooseFlgs" column multiple class="mx-1">
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="primary"
                text-color="white"
                :key="1"
                :value="1"
                >{{ $t("CRUD.choosed") }}</v-chip
              >
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="grey"
                text-color="white"
                :key="0"
                :value="0"
                >{{ $t("CRUD.unchoose") }}</v-chip
              >
            </v-chip-group>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="templateItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        height="340px"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              templates.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{ $t("CRUD.chooseCount", [choosedLength, newChoosedArr.length]) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Template from "@/api/templates";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import consts from "@/consts";

export default {
  name: "TemplatesSelectsDialog",

  props: {
    fullField: Boolean,
    value: Boolean,
    changed: Array,
    templateIds: Array,
    options: Object,
    disabledIds: Array,
  },

  components: {
    SearcherKeyword,
  },

  computed: {
    headers: () => [
      {
        text: i18n.t("Template.Fields.template_name"),
        align: "start",
        sortable: true,
        filterable: true,
        value: "template_name",
      },
      {
        text: i18n.t("Template.Fields.material_count"),
        align: "center",
        sortable: false,
        filterable: false,
        value: "material_count",
      },
      {
        text: i18n.t("Template.Fields.shop_count", [consts.shopName()]),
        align: "center",
        sortable: false,
        filterable: false,
        value: "shop_count",
      },
      {
        text: i18n.t("CRUD.chooseAll"),
        align: "start",
        sortable: false,
        filterable: true,
        value: "choose",
      },
    ],

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    templateItems() {
      //前端搜索
      return this.templates
          .filter(
        (item) =>
          ((this.chooseFlgs.length &&
            (item.choose
              ? this.chooseFlgs.find((flg) => flg == item.choose) !=
                  undefined || !item.disabled
              : this.chooseFlgs.find((flg) => flg == item.choose) !=
                undefined)) ||
            !this.chooseFlgs.length) &&
          (this.templateKeyword && (item.template_name.indexOf(this.templateKeyword) > -1) ||
            !this.templateKeyword)
      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    templates: [],
    templateKeyword: "",
    chooseFlgs: [0],
    itemsPerPageOptions: 10,
    templateIdsChoosed: [],
    templateIdsDisabled: [],
    chooseAll: 0,
    newChoosedArr: [],
    choosedLength: 0,
    fetchTimestamp: 0, //第一次获取供应商列表的时间
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.templateKeyword = this.KeyWord;
    },

    //获取供应商列表
    getTemplatesFromAPI() {
      if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) {
        this.templates = this.templates.map((template) => {
          if (
            this.templateIdsChoosed.indexOf(template.id) > -1 &&
            (!template.choose || !template.disabled)
          ) {
            template = Object.assign({}, template, {
              choose: 1,
              disabled: true,
            });
          } else if (
            this.templateIdsChoosed.indexOf(template.id) == -1 &&
            (template.choose == 1 || template.disabled)
          ) {
            if (template.choose == 1) {
              template.choose = 0;
            }
            if (template.disabled) {
              template.disabled = false;
            }
          }
          if (this.templateIdsDisabled.indexOf(template.id) > -1) {
            template.disabled = true;
          }

          return template;
        });
        return;
      }

      let options = this.options;
      Template.fetchAllForSelect(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.templates = response.data.templates.map((template) => {
              //默认勾选
              if (this.templateIdsChoosed.indexOf(template.id) > -1) {
                template = Object.assign({}, template, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (template.choose == 1 || !template.choose) {
                  template.choose = 0;
                }
                if (template.disabled) {
                  template.disabled = false;
                }
              }
              if (this.templateIdsDisabled.indexOf(template.id) > -1) {
                template.disabled = true;
              }
              return template;
            });

            this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },

    saveChoose() {
      this.dialog = false;
      this.$emit("confirm", this.newChoosedArr);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          if (this.templateIds && this.templateIds.length) {
            this.templateIdsChoosed = JSON.parse(
              JSON.stringify(this.templateIds)
            );
          } else {
            this.templateIdsChoosed = [];
          }
          if (this.disabledIds && this.disabledIds.length) {
            this.templateIdsDisabled = JSON.parse(
              JSON.stringify(this.disabledIds)
            );
          }

          this.choosedLength = this.templateIdsChoosed.length;
          this.getTemplatesFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.newChoosedArr = [];
          this.templateKeyword = "";
          this.chooseFlgs = [0];
          this.chooseAll = false;
        }
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        this.templates = this.templates.map(
          function (e) {
            var item = this.templateItems.find((m) => m.id == e.id && !e.disabled);
            if (item) e.choose = this.chooseAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    templates: {
      deep: true,
      handler() {
        //整理新增商品
        this.templates.forEach((template) => {
          if (
              template.choose &&
            !this.templateIdsChoosed.includes(template.id) &&
            !this.newChoosedArr.find(
              (new_choosed) =>
                new_choosed.id == template.id
            )
          ) {
            this.newChoosedArr.push(template);
            this.choosedLength = this.choosedLength + 1;
          } else if (
            !template.choose &&
            this.newChoosedArr.find(
              (new_choosed) =>
                new_choosed.id == template.id
            )
          ) {
            this.newChoosedArr.splice(
              this.newChoosedArr.findIndex(
                (new_choosed) =>
                  new_choosed.id == template.id
              ),
              1
            );
            this.choosedLength = this.choosedLength - 1;
          }
        });
      },
    },
  },
};
</script>